import React, {useState} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {Button, Modal as M} from 'react-bootstrap';

export const ModalesMiPerfil = (props) => {
	const {
		modalBorrrarCuenta,
		setModalBorrrarCuenta,
		modalGuardarCambios,
		setModalGuardarCambios,
		Usuario,
		setUsuario,
		guardarCambios,
		eliminarPerfil,
	} = props;

	return (
		<>
			<M
				centered={true}
				show={modalBorrrarCuenta}
			>
				<M.Header>
					<div className='titulo-modal'>Borrar Cuenta</div>
				</M.Header>
				<M.Body>
					<div className='descripcion-servicio descripcion-modal'>
						¿Esta seguro de que desea eliminar esta cuenta?
					</div>
				</M.Body>
				<M.Footer>
					<div className='centrador-Botones-botones-perfil-empresa'>
						<button
							className='btn outline-boton'
							onClick={() => setModalBorrrarCuenta(false)}
						>
							<b>Cancelar</b>
						</button>
						<button
							className='btn btn-outline-danger'
							onClick={() => eliminarPerfil()}
						>
							<b>Aceptar</b>
						</button>
					</div>
				</M.Footer>
			</M>
			<M
				centered={true}
				show={modalGuardarCambios}
			>
				<M.Header>
					<div className='titulo-modal'>Guardar</div>
				</M.Header>
				<M.Body>
					<div className='descripcion-servicio descripcion-modal'>¿Estás seguro de que quieres guardar los datos?</div>
				</M.Body>
				<M.Footer>
					<div className='centrador-Botones-botones-perfil-empresa'>
						<button
							className='btn btn-outline-danger'
							onClick={() => setModalGuardarCambios(false)}
						>
							Cancelar
						</button>
						<button
							className='btn login-boton'
							onClick={() => guardarCambios()}
						>
							<b>Aceptar</b>
						</button>
					</div>
				</M.Footer>
			</M>
		</>
	);
};
